// Port of api/fuel/app/classes/filter/search/games/sorts/query/game/name.php
import F from 'offline/filter/constants'
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'name',
	post: false,
	require: function(config, filter) {
		return !filter.source['list'] && (!filter.source['list.sorted'] || (filter.source['list.sorted'] && filter.sort !== 'list.rank')) && !filter.nosort
	},
	run: function(config, filter, data, query) {
		var reverse = sortReverse('name', filter)
		var priority = sortPriority('name', filter, 1000)
		query.leftjoin('z')

		// LOWER() wraps are needed because SQLite uses binary collation by default,
		// whereas MySQL uses utf8_general_ci (case-insensitive). Custom rename text
		// is stored with original casing, game_sortname is already lowercase.
		if (config.ownerType === F.OWNER_USER) {
			var collectionOnlySource =
				filter.source &&
				filter.source.collection &&
				!filter.source.ratings &&
				!filter.source.plays

			if (collectionOnlySource) {
				query.leftjoin('v')

				if (config.resultType === F.RESULT_COLLECTION) {
					query.leftjoin('y')
					query.order('LOWER(COALESCE(z.custom_rename_text, y.custom_rename_text, NULLIF(v.game_version_sort, \'\'), g.game_sortname))', reverse, priority)
				} else {
					query.order('LOWER(COALESCE(z.custom_rename_text, NULLIF(v.game_version_sort, \'\'), g.game_sortname))', reverse, priority)
				}
			} else {
				query.order('LOWER(COALESCE(z.custom_rename_text, g.game_sortname))', reverse, priority)
			}
		} else {
			query.order('g.game_sortname', reverse, priority)
		}
		// Deterministic tiebreakers for equal sortnames (and equal sortname
		// + game_id, which happens for duplicate collection rows — e.g.
		// own=1 AND prevowned=1 on the same game, or two versions of the
		// same game). MySQL/SQLite both leave ties unordered without this,
		// so page-N cursors diverge between engines on users with thousands
		// of collection rows.
		query.order('g.game_id', false, priority + 1)
		if (config.resultType === F.RESULT_COLLECTION) {
			query.order('c.collection_id', false, priority + 2)
		}
	}
}
